import { ReactElement } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import {
  PaginationQuery,
  PaginationRequestType,
} from '../../../../types/paginationRequestType';
import { adminPaginated } from '../../api';
import { Announcement } from '../../types';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  PaginationQuery,
  PaginationRequestType<Announcement>,
  AxiosResultDefaultError
>();

export function useAnnouncementAdminListLoader() {
  return useFetch();
}

export const AnnouncementAdminListLoaderConsumer = FetchConsumer;

export default function AnnouncementAdminListLoader({
  children,
}: BaseLoaderProps) {
  return (
    <FetchProvider
      request={adminPaginated}
      defaultQuery={{ page: 1, items_per_page: 10 }}
      fetchImmediately
    >
      {children}
    </FetchProvider>
  );
}
